/**
 * @param {string} string - camelCasedString
 * @returns spaced String
 *
 * @example
 * splitCamelCase('camelCasedString');
 */
export default function splitCamelCase(string) {
  if (string && typeof string === 'string') {
    return `${string}`.replace(/([a-z0-9])([A-Z])/g, '$1 $2').replace(/([a-z])([A-Z0-9])/g, '$1 $2');
  }
  return '';
}